import React from "react";
import { ycCompanies } from "assets/ycCompanies";
import { Link } from "react-router-dom";
import moment from "moment";

const headerColumns = {
  companyName: {
    name: "Company",
    width: "35%",
  },
  clientId: {
    name: "Client ID",
    width: "10%",
  },
  clientUsername: {
    name: "Client Username",
    width: "25%",
  },
  numOrders: {
    name: "Orders",
    width: "10%",
  },
  lastActive: {
    name: "Last Active",
    width: "20%",
  },
};

export default function ClientsPageTable() {
  return (
    <table className="w-full text-sm text-left">
      <thead className="text text-gray-800 bg-gray-59">
        <tr>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.companyName.width }}>
            {headerColumns.companyName.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.clientId.width }}>
            {headerColumns.clientId.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.clientUsername.width }}>
            {headerColumns.clientUsername.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.numOrders.width }}>
            {headerColumns.numOrders.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.lastActive.width }}>
            {headerColumns.lastActive.name}
          </th>
        </tr>
      </thead>
      <tbody>
        {ycCompanies.map((company) => {
          const { companyName } = company;
          var formattedCompanyName = companyName.substring(0, companyName.indexOf("("));
          formattedCompanyName = formattedCompanyName.trim().replace(/\s/g, "-").toLowerCase();
          const clusterURL = `/recruiters/@agave/clients/@${formattedCompanyName}`;

          return (
            <tr className="cursor-pointer bg-white border-b hover:bg-gray-50 text-gray-700">
              <td className="flex items-center px-6 py-4">
                <img className="w-10 h-10 rounded-full" src={company.profileImageURL} alt={company.roleName} />
                <div className="pl-3">
                  <div className="text-base font-semibold">
                    <Link to={clusterURL}>{company.companyName}</Link>
                  </div>
                  <div className="font-normal">{company.location}</div>
                </div>
              </td>
              <td className="px-6 py-4">{Math.floor(Math.random() * 10210)}</td>
              <td className="px-6 py-4">{`@${formattedCompanyName}`}</td>
              <td className="px-6 py-4">{Math.floor(Math.random() * 10210)}</td>
              <td className="px-6 py-4">{moment(new Date()).format("ddd, MMM Do")}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
